import { render, staticRenderFns } from "./ClaimLimitSetupNew.vue?vue&type=template&id=08f69214"
import script from "./ClaimLimitSetupNew.vue?vue&type=script&lang=js"
export * from "./ClaimLimitSetupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports